module.exports = __webpack_public_path__ + "static/07-hand-shaking 1-dba396fb1d1f833c5e4c4105c734dead.svg";